import { generateQueryKey } from '../../../../utils/generate-query-key';
export const getQueryKeyForFilmAvailability = (filmAvailability) => {
    const { filmId, siteId } = filmAvailability;
    return generateQueryKey({ filmId, siteId });
};
